<template>
  <div>
      <b-modal ref="modal" title="Contas Recebidas" header-class="border-bottom-0" size="xs">
     
       <div class="row">
          <div class="card w-100">
            <div class="card-body">
              <div class="col-md-12">
                <div class="d-flex">
                  <div class="mr-3">
                    <avatar inline color="#fff" 
                    :size="40" 
                    :username="person.name" 
                    :initials="getInitial(person.name)">
                    </avatar>
                  </div>
                  <div>
                    {{person.name}}
                    <br />
                    <small class="text-muted">{{ person.cpf}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
       </div>
    
     
      <br/>
       <div class="row grid-table-heading">
        <div class="col-md-4 col-12">Documento</div>
        <div class="col-md-4 col-12">Valor</div>  
        <div class="col-md-4 col-12">Desconto</div>
      </div>
      
      <hr/>

       <template v-for="row in payment.bill_payment_join_bill" >
        <div class="row grid-table-row" :key="row.id" > 

          <div class="col-md-4 col-12">
              <span>{{ row.document }}</span> 
            <br />
            <small class="text-muted">Pago em: {{ row.payed_at | dateBr }}</small>
            <br>
          </div>

           <div class="col-md-4 col-12">
              <span>{{ row.received_value | decimal}}</span> 
          </div>

           <div class="col-md-4 col-12">
              <span>{{ row.discount | decimal  }}</span> 
          </div>
        </div>
      </template>
      </b-modal>
  </div>

</template>

<script>
import Avatar from "vue-avatar";

export default {
   components: { Avatar },

  data: function() {
    return {

      payment: {
        bill_payment_join_bill: []        
      },

      person: {
        name : ''
      }

    }
  },
  methods : {

     getInitial(value) {
      return value.slice(0, 1);
    },
    
    open(accountTransactionId) {
      
      axios
        .post('api/accounttransactionbillpayment/select/' + accountTransactionId)
        .then(response => {

          this.payment = response.data.payment;
          this.person = response.data.person;
           
          this.$refs.modal.show()
          
          this.$store.commit("hideLoading");
        })
        .catch(error => {
          this.$store.commit("hideLoading");
          this.error = error;
        });

    }
    
  }
}
</script>

<style>

</style>